<template>
  <v-dialog
      v-model="showQq"
      persistent
      width="800"
  >
    <v-card
        v-if="loading"
        class="pa-4"
    >
      <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
      ></v-progress-linear>
    </v-card>
    <v-card
        v-else
        class="pa-8"
    >
        <button
                @click="close"
                class="close mb-4"
        >
          ✖
        </button>
      <template v-for="(question, indx) in questions">
        <div class="d-flex justify-content-between" :key="'q-' + indx">
          <div class="q-list">
            {{ question.question }}
          </div>
          <div>
            <v-chip-group
                v-model="question.answer"
                class="mx-auto normal-chips"
                group
                color="black"
                active-class="w-border"
                :class="question.answer != null ? 'all-grey' : ''"
            >
                <v-chip
                    :value="true"
                    :color="btnClr(0)"
                >
                  Да
                </v-chip>
              <v-chip
                    :value="false"
                    :color="btnClr(1)"
                >
                  Нет
                </v-chip>
            </v-chip-group>
          </div>
        </div>
      </template>
      <v-card-actions>
        <v-btn
            @click="submit"
            class="mx-auto"
            :disabled="noAllChecked"
        >
          Далее
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'questionnaire',
  props: ['qtype', 'showQq'],
  data() {
    return {
      questions: null,
      loading: true,
    }
  },
  computed: {
    noAllChecked () {
      let notAllChecked = false
      this.questions.forEach((q) => {
        if (q.answer === null && (q.type === this.qtype || q.type === 'general')) {
          notAllChecked = true
        }
      })
      return notAllChecked
    },
  },
  watch: {
    showQq (newVal) {
      if (newVal) {
        console.log(this.qtype)
        const questType = this.qtype
        this.$store.dispatch('questionnaire/getQuestions', questType).then((resp) => {
          if (resp.data.questions && resp.data.questions.length > 0) {
            resp.data.questions.forEach((q)=> { q.answer = null })
            this.questions = resp.data.questions
            this.loading = false
          } else {
            this.$emit('submit', null)
          }
        }).catch((e) => {
          console.log('Error', e)
        })
      }
    },
  },
  methods: {
    btnClr(indx) {
      const colors = ['#a2f3a2', '#e18e8b', '#e2e868']
      return colors[indx]
    },
    close() {
      this.$emit('close')
    },
    submit() {
      this.$emit('submit', () => this.$store.dispatch('questionnaire/sendAnswers', [this.qtype, this.questions]))
    },
    sendAndNext () {
      // todo error info !!!!
      this.$store.dispatch('questionnaire/sendAnswers', [this.type, this.questions]).then(() => {
        this.$emit('closeAndNext')
      })
    }
  }
}
</script>

<style scoped>
  .q-list {
    font-size: larger;
  }
  .w-border {
    box-shadow:0px 0px 0px 2px #000a51 inset;
  }
  .all-grey span.v-chip:not(.w-border){
    opacity: 20%;
  }
  .normal-chips .v-chip {
    border-radius: 6px;
  }
  .close {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 2;
  }
</style>
